/**
 * Client-side plugin that fetches the CSRF token on app boot.
 *
 * This async plugin runs before the app mounts, guaranteeing that csrfToken.value
 * is populated before any component makes a CSR request.
 */
export default defineNuxtPlugin(async () => {
    if (process.env.NODE_ENV === 'test' || process.env.VITEST === 'true') {
        return
    }

    const csrfToken = useState<string>('csrf-token')

    try {
        const response = await $fetch<{ token: string }>('/api/csrf-refresh')
        csrfToken.value = response.token
    } catch (error) {
        console.error('Failed to fetch CSRF token:', error)
    }
})
